$(document).ready(function () {

    $(document).on("click", ".confirmLink", function (e) {

        let link = $(this);

        confirmEvent(e, link, function () {

            let url = link.data("href");
            let ajax = link.data("ajax");

            if (ajax === "on") {
                $.nette.ajax({
                    url: url,
                    type: "GET",
                    off: {
                        snippets: true
                    }
                });
            } else {
                window.location.href = url;
            }

        });

    });

    $(document).on("click", ".confirmFormBtn", function (e) {

        let btn = $(this);
        confirmEvent(e, btn, function (formData) {

            $.nette.ajax({
                url: btn.closest('form').attr('action'),
                data: formData,
                type: "POST",
                off: {
                    snippets: true
                }
            });

        });

    });

});




